/**
 * @author      yontaek@zumper.com (Yon Taek Chung)
 * @copyright   Copyright (c) 2022, Zumper
 * @description getRelativeUrlFromFiltersAndLocation
 */

import type { Filters } from '@zcode/state-type'

import { FILTERS_START_RE } from './constants'
import { getPathFromFilters } from './getPathFromFilters'
import { getSearchUrlFromPathAndFilters } from './getSearchUrlFromPathAndFilters'

export const getRelativeUrlFromFiltersAndLocationHelper = (
  filters: Filters,
  oldUrl: string,
  bubbleId?: string
) => {
  let url = oldUrl
  const m = FILTERS_START_RE.exec(url)
  if (m) {
    url = url.slice(0, m.index)
  }
  url = url.replace(/\/+$/, '')

  // bubble id
  if (bubbleId) {
    url += `/${bubbleId}`
  }
  url += getPathFromFilters(filters)
  // ensure path is relative
  return url[0] === '/' ? url.replace(/^[/]*/, '') : url
}

export const getRelativeUrlFromFiltersAndLocation = ({
  bubbleId,
  currentUrl,
  filters,
  locationUrlQueries,
  omitBox,
}: {
  bubbleId?: string
  currentUrl: string
  filters: Filters
  locationUrlQueries?: string[]
  omitBox?: boolean
}) => {
  const path = getRelativeUrlFromFiltersAndLocationHelper(filters, currentUrl, bubbleId)
  return getSearchUrlFromPathAndFilters({
    filters,
    locationUrlQueries,
    omitBox,
    path,
  })
}
